const initialState = {
    allCourses: [],
    attemptedTestIds: []
}

const courseReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_COURSES':
            return { ...state, allCourses: action.data }
        case 'SET_ATTEMPTED_TESTS':
            return { ...state, attemptedTestIds: action.data }
        default:
            return state
    }
}

export default courseReducer
